<template>
  <div>
    <button class="button fullScreenButton" @click="toggleFullscreen">
      <span class="tooltip">{{ fullscreenMode ? 'Fullscreen Off' : 'Fullscreen On'}}</span>
      <i class="material-icons">{{ fullscreenMode ? 'fullscreen_exit' : 'fullscreen' }}</i>
    </button>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'

export default {
  computed: {
    ...mapState([
      'fullscreenMode'
    ])
  },
  methods: {
    ...mapMutations([
      'toggleFullscreen'
    ])
  }
}
</script>

<style>

</style>